(() => {
  const initialise = (root) => {
    if (!root || root.dataset.opxReady === 'true') return;
    root.dataset.opxReady = 'true';

    root.querySelectorAll('[data-opx-oil-compare]').forEach((comparison) => {
      const track = comparison.querySelector('.opx-oil-compare__scroll');
      const navigation = comparison.querySelector('.opx-oil-compare__navigation');
      const previous = comparison.querySelector('[data-oil-scroll="previous"]');
      const next = comparison.querySelector('[data-oil-scroll="next"]');
      if (!track || !navigation || !previous || !next) return;
      const refresh = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.abs(track.scrollLeft);
        navigation.hidden = maximum < 2;
        previous.disabled = position < 2;
        next.disabled = position >= maximum - 2;
      };
      const move = (direction) => {
        const column = track.querySelector('td');
        const distance = column?.getBoundingClientRect().width || 140;
        track.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(1));
      next.addEventListener('click', () => move(-1));
      track.addEventListener('scroll', refresh, { passive: true });
      const observer = new ResizeObserver(refresh);
      observer.observe(track);
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      refresh();
    });

    const gallery = root.querySelector('[data-opx-gallery-track]');
    const gallerySlides = [...root.querySelectorAll('[data-opx-gallery-slide]')];
    const galleryNav = root.querySelector('[data-opx-gallery-nav]');
    const galleryThumbnails = [...root.querySelectorAll('[data-opx-gallery-thumbnail]')];
    let galleryIndex = 0;

    const setGalleryIndex = (index) => {
      if (galleryIndex !== index) {
        gallerySlides[galleryIndex]?.querySelectorAll('video').forEach((video) => video.pause());
        gallerySlides[galleryIndex]?.querySelectorAll('iframe').forEach((frame) => {
          frame.src = frame.src;
        });
      }
      galleryIndex = index;
      galleryThumbnails.forEach((thumbnail, thumbnailIndex) => {
        const selected = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', selected);
        thumbnail.setAttribute('aria-current', String(selected));
      });
      const thumbnail = galleryThumbnails[index];
      if (!galleryNav || !thumbnail) return;
      const navRect = galleryNav.getBoundingClientRect();
      const thumbnailRect = thumbnail.getBoundingClientRect();
      if (thumbnailRect.left < navRect.left || thumbnailRect.right > navRect.right) {
        galleryNav.scrollBy({
          left: thumbnailRect.left + thumbnailRect.width / 2 - navRect.left - navRect.width / 2,
          behavior: 'instant'
        });
      }
    };

    galleryThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = Number(thumbnail.dataset.opxGalleryThumbnail || 0);
        const slide = gallerySlides[index];
        if (!gallery || !slide) return;
        const galleryRect = gallery.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        gallery.scrollBy({
          left: slideRect.left + slideRect.width / 2 - galleryRect.left - galleryRect.width / 2,
          behavior: 'instant'
        });
        setGalleryIndex(index);
      });
    });

    if (gallery && gallerySlides.length > 1) {
      let galleryFrame;
      gallery.addEventListener('scroll', () => {
        window.cancelAnimationFrame(galleryFrame);
        galleryFrame = window.requestAnimationFrame(() => {
          const galleryRect = gallery.getBoundingClientRect();
          const galleryCenter = galleryRect.left + galleryRect.width / 2;
          let nearestIndex = 0;
          let nearestDistance = Infinity;
          gallerySlides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const distance = Math.abs(slideRect.left + slideRect.width / 2 - galleryCenter);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });
          setGalleryIndex(nearestIndex);
        });
      }, { passive: true });
    }

    const variantInput = root.querySelector('[data-opx-variant-id]');
    const currentPrice = root.querySelector('[data-opx-price-current]');
    const comparePrice = root.querySelector('[data-opx-price-compare]');
    const saleBadge = root.querySelector('[data-opx-sale-badge]');
    const addButton = root.querySelector('[data-opx-add]');
    const addLabel = root.querySelector('[data-opx-add-label]');
    const sticky = root.querySelector('[data-opx-sticky]');
    const stickyButton = root.querySelector('[data-opx-sticky-add]');
    const stickyPrice = root.querySelector('[data-opx-sticky-price]');
    const stickyCompare = root.querySelector('[data-opx-sticky-compare]');
    const stickyLabel = root.querySelector('[data-opx-sticky-label]');
    const stickyTitle = root.querySelector('[data-opx-sticky-title]');
    const stickyImage = root.querySelector('[data-opx-sticky-image]');
    const stickyImageWrap = root.querySelector('[data-opx-sticky-image-wrap]');
    const stickyProducts = JSON.parse(root.querySelector('[data-opx-sticky-products]')?.textContent || '[]');
    const syncSticky = () => {
      if (stickyPrice && currentPrice) stickyPrice.textContent = currentPrice.textContent.replace(/\.00$/, '');
      if (stickyCompare && comparePrice) {
        stickyCompare.hidden = comparePrice.hidden;
        stickyCompare.textContent = comparePrice.textContent.replace(/\.00$/, '');
      }
      const selectedProduct = stickyProducts.find((item) => String(item.id) === variantInput?.value);
      if (selectedProduct) {
        if (stickyTitle) stickyTitle.textContent = selectedProduct.title;
        if (stickyImageWrap) {
          stickyImageWrap.hidden = !selectedProduct.image;
          stickyImageWrap.classList.toggle('opx-sticky__image--oil', selectedProduct.oil === true);
        }
        if (stickyImage && selectedProduct.image && stickyImage.getAttribute('src') !== selectedProduct.image) {
          stickyImage.removeAttribute('srcset');
          stickyImage.src = selectedProduct.image;
        }
      }
      if (!stickyButton || !addButton) return;
      const busy = addButton.classList.contains('loading');
      stickyButton.disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
      stickyButton.setAttribute('aria-busy', String(busy));
      if (stickyLabel) stickyLabel.textContent = busy ? stickyButton.dataset.loadingLabel : addButton.disabled ? addLabel?.textContent || addButton.textContent.trim() : stickyButton.dataset.addLabel;
    };

    root.querySelectorAll('[data-opx-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-opx-variant]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
          item.closest('.opx-offer')?.classList.remove('is-selected');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        button.closest('.opx-offer')?.classList.add('is-selected');
        if (variantInput) variantInput.value = button.dataset.id;
        if (currentPrice) currentPrice.textContent = button.dataset.price;

        const hasDiscount = Boolean(button.dataset.compare);
        if (comparePrice) {
          comparePrice.hidden = !hasDiscount;
          comparePrice.textContent = button.dataset.compare || '';
        }
        if (saleBadge) {
          saleBadge.hidden = !hasDiscount;
          saleBadge.textContent = hasDiscount ? `وفّري ${button.dataset.discount}٪` : '';
        }

        const available = button.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? (button.dataset.addLabel || 'أضيفي إلى السلة') : 'نفد من المخزون';
        syncSticky();
      });
    });

    root.querySelectorAll('[data-opx-drag]').forEach((track) => {
      let active = false;
      let startX = 0;
      let startScroll = 0;
      const down = (event) => {
        active = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.setPointerCapture?.(event.pointerId);
      };
      const move = (event) => {
        if (!active) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      };
      const up = () => { active = false; };
      track.addEventListener('pointerdown', down);
      track.addEventListener('pointermove', move);
      track.addEventListener('pointerup', up);
      track.addEventListener('pointercancel', up);
      track.addEventListener('dragstart', (event) => event.preventDefault());
    });

    const reveals = root.querySelectorAll('[data-opx-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
      reveals.forEach((element) => revealObserver.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    const purchase = root.querySelector('[data-opx-purchase]');
    if (purchase && sticky && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.inert = !visible;
      }, { threshold: 0 });
      stickyObserver.observe(purchase);
    }

    stickyButton?.addEventListener('click', () => {
      if (addButton && !stickyButton.disabled) addButton.click();
    });
    if (addButton) {
      const buttonObserver = new MutationObserver(syncSticky);
      buttonObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, characterData: true, subtree: true });
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (!event.target.contains(root)) return;
        buttonObserver.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      });
    }
    syncSticky();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-opx-product]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
